import React, { useEffect, useRef } from 'react';
import { Animated, ViewStyle } from 'react-native';
import { createFadeInAnimation, createSlideInAnimation } from '../utils/animations';

interface ScreenTransitionProps {
  children: React.ReactNode;
  style?: ViewStyle;
  transitionType?: 'fade' | 'slideFromRight' | 'slideFromBottom';
  duration?: number;
}

export const ScreenTransition: React.FC<ScreenTransitionProps> = ({
  children,
  style,
  transitionType = 'fade',
  duration = 250,
}) => {
  const fadeAnim = useRef(new Animated.Value(0)).current;
  const slideAnim = useRef(new Animated.Value(30)).current;

  useEffect(() => {
    const animations = [];

    switch (transitionType) {
      case 'fade':
        animations.push(createFadeInAnimation(fadeAnim, duration));
        break;
      case 'slideFromRight':
        slideAnim.setValue(30);
        animations.push(createSlideInAnimation(slideAnim, 30, duration));
        animations.push(createFadeInAnimation(fadeAnim, duration));
        break;
      case 'slideFromBottom':
        slideAnim.setValue(20);
        animations.push(createSlideInAnimation(slideAnim, 20, duration));
        animations.push(createFadeInAnimation(fadeAnim, duration));
        break;
    }

    Animated.parallel(animations).start();
  }, []);

  const getAnimatedStyle = () => {
    const baseStyle = {
      opacity: fadeAnim,
    };

    if (transitionType === 'slideFromRight') {
      return {
        ...baseStyle,
        transform: [{ translateX: slideAnim }],
      };
    }

    if (transitionType === 'slideFromBottom') {
      return {
        ...baseStyle,
        transform: [{ translateY: slideAnim }],
      };
    }

    return baseStyle;
  };

  return (
    <Animated.View style={[{ flex: 1 }, style, getAnimatedStyle()]}>
      {children}
    </Animated.View>
  );
};